// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDarregapproveIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDarregapproveIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDarregapproveIconOutlined = function DrrpDarregapproveIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDarregapproveIconOutlinedSvg
  }));
};

DrrpDarregapproveIconOutlined.displayName = 'DrrpDarregapproveIconOutlined';
export default React.forwardRef(DrrpDarregapproveIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDarregapproveIconOutlined.js
// module id = 2530
// module chunks = 0